var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.93,
    y: 49.68,
    width: 147.58,
    height: 95.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33.83,
    y1: 168.47,
    x2: 179.61,
    y2: 168.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 52.73,
    y1: 158.57,
    x2: 52.73,
    y2: 178.37
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "83.32 69.48 83.32 126.18 130.12 98.28 83.32 69.48"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/VIDEO.edda49ad7c57d888079c3ef672155ee4.svg";
export { ForwardRef as ReactComponent };